import { Component } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from './core/services/auth.service';
import {TranslateService} from '@ngx-translate/core';
import {AppConfig} from '../../config';

@Component({
  selector: 'app-minton',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor( public translate: TranslateService) {
    this.translate.addLangs(AppConfig.languages);
    if (localStorage.getItem('locale')) {
      const browserLang = localStorage.getItem('locale');
      const matcher = '/' + AppConfig.languages.join('|') + '/';
      translate.use(browserLang.match(matcher) ? browserLang : AppConfig.defaultLanguage);
    } else {
      localStorage.setItem('locale', AppConfig.defaultLanguage);
      translate.setDefaultLang(AppConfig.defaultLanguage);
    }
  }
}
